import React from 'react';

const ProjectsPage = () => {
  return <>project page</>;
};

export default ProjectsPage;
